var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-card", { staticClass: "liveinfo-form", attrs: { "no-body": "" } }, [
        _c(
          "div",
          { staticClass: "m-2" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-start mb-1 mb-md-0",
                    attrs: { cols: "12" },
                  },
                  [
                    _c("v-select", {
                      staticClass: "el-def",
                      attrs: {
                        options: _vm.codes.giftCompany,
                        placeholder: "기프티콘 업체",
                        reduce: function (option) {
                          return option.code
                        },
                      },
                      model: {
                        value: _vm.query.company,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "company", $$v)
                        },
                        expression: "query.company",
                      },
                    }),
                    _c("b-form-datepicker", {
                      staticClass: "el-def",
                      attrs: { placeholder: "등록일(From)" },
                      model: {
                        value: _vm.query.startDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "startDate", $$v)
                        },
                        expression: "query.startDate",
                      },
                    }),
                    _c("label", { staticClass: "ml-25 mr-50" }, [_vm._v("~")]),
                    _c("b-form-datepicker", {
                      staticClass: "el-def",
                      attrs: { placeholder: "등록일(To)" },
                      model: {
                        value: _vm.query.endDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "endDate", $$v)
                        },
                        expression: "query.endDate",
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "b-row",
              { staticClass: "mt-1" },
              [
                _c(
                  "b-col",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-start mb-1 mb-md-0",
                    attrs: { cols: "12", md: "10" },
                  },
                  [
                    _c("v-select", {
                      staticClass: "el-def",
                      attrs: {
                        options: _vm.codes.isFailure,
                        placeholder: "성공여부",
                        reduce: function (option) {
                          return option.code
                        },
                      },
                      model: {
                        value: _vm.query.isFailure,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "isFailure", $$v)
                        },
                        expression: "query.isFailure",
                      },
                    }),
                    _c("v-select", {
                      staticClass: "el-def",
                      attrs: {
                        options: _vm.codes.giftRewardTraceType,
                        placeholder: "보상 구분",
                        reduce: function (option) {
                          return option.code
                        },
                      },
                      model: {
                        value: _vm.query.rewardType,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "rewardType", $$v)
                        },
                        expression: "query.rewardType",
                      },
                    }),
                    _c("b-form-input", {
                      staticClass: "el-def",
                      staticStyle: { width: "300px" },
                      attrs: { placeholder: "검색어 입력(휴대전화번호)" },
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.refetchData()
                        },
                      },
                      model: {
                        value: _vm.query.filterStr,
                        callback: function ($$v) {
                          _vm.$set(_vm.query, "filterStr", $$v)
                        },
                        expression: "query.filterStr",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  {
                    staticClass:
                      "d-flex align-items-center justify-content-end",
                    attrs: { cols: "12", md: "2" },
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn-search mr-50",
                        attrs: { variant: "primary" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.refetchData()
                          },
                        },
                      },
                      [_vm._v(" 조회 ")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "div",
            { staticClass: "m-2" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-start",
                      attrs: { md: "6" },
                    },
                    [
                      _c("h5", { staticClass: "mb-0 ml-50" }, [
                        _vm._v(
                          " 발송 리스트 [" + _vm._s(_vm.totalRecords) + "] 건 "
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-end",
                      attrs: { cols: "12", md: "6" },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "btn-search",
                          attrs: { variant: "outline-dark" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.excelDown()
                            },
                          },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-50",
                            attrs: { icon: "DownloadIcon" },
                          }),
                          _c("span", [_vm._v("다운로드")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("b-table", {
            staticClass: "position-relative",
            staticStyle: { "max-height": "65vh", "font-size": "12px" },
            attrs: {
              "no-wrap": true,
              items: _vm.resultTable,
              fields: _vm.tableColumns,
              "sort-by": _vm.sortBy,
              "sort-desc": _vm.isSortDesc,
              responsive: "",
              selectable: "",
              "sticky-header": "",
              "select-mode": "single",
            },
            on: {
              "update:sortBy": function ($event) {
                _vm.sortBy = $event
              },
              "update:sort-by": function ($event) {
                _vm.sortBy = $event
              },
              "update:sortDesc": function ($event) {
                _vm.isSortDesc = $event
              },
              "update:sort-desc": function ($event) {
                _vm.isSortDesc = $event
              },
            },
            scopedSlots: _vm._u([
              {
                key: "cell(id)",
                fn: function (data) {
                  return [_vm._v(" " + _vm._s(data.value) + " ")]
                },
              },
              {
                key: "cell(cancelDate)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          "justify-content": "center",
                          "align-items": "center",
                        },
                      },
                      [
                        data.item.isCancel === true
                          ? _c("span", { staticClass: "text-nowrap" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("$dateFormatter")(
                                      data.value,
                                      "YYYY-MM-DD"
                                    )
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        data.item.isCancel === true
                          ? _c("span", { staticClass: "text-nowrap" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("$dateFormatter")(
                                      data.value,
                                      "HH:mm"
                                    )
                                  ) +
                                  " "
                              ),
                            ])
                          : _c(
                              "b-button",
                              {
                                staticClass: "mr-1",
                                class: { hidden: data.item.isFailure },
                                attrs: {
                                  variant: "outline-danger",
                                  size: "sm",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.confirmModal("cancel", data.item)
                                  },
                                },
                              },
                              [_c("span", [_vm._v("취소")])]
                            ),
                      ],
                      1
                    ),
                  ]
                },
              },
              {
                key: "cell(reOrderDate)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          "justify-content": "center",
                          "align-items": "center",
                        },
                      },
                      [
                        data.item.isReOrder === true
                          ? _c("span", { staticClass: "text-nowrap" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("$dateFormatter")(
                                      data.value,
                                      "YYYY-MM-DD"
                                    )
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        data.item.isReOrder === true
                          ? _c("span", { staticClass: "text-nowrap" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("$dateFormatter")(
                                      data.value,
                                      "HH:mm"
                                    )
                                  ) +
                                  " "
                              ),
                            ])
                          : _c(
                              "b-button",
                              {
                                staticClass: "mr-1",
                                class: { hidden: !data.item.isFailure },
                                attrs: {
                                  variant: "outline-primary",
                                  size: "sm",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.confirmModal(
                                      "reorder",
                                      data.item
                                    )
                                  },
                                },
                              },
                              [_c("span", [_vm._v("재발송")])]
                            ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("b-pagination", {
            attrs: {
              "total-rows": _vm.totalRecords,
              limit: "10",
              "per-page": "20",
              align: "center",
            },
            model: {
              value: _vm.currPage,
              callback: function ($$v) {
                _vm.currPage = $$v
              },
              expression: "currPage",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "b-modal",
            {
              attrs: {
                title: "발송 된 기프티콘을 취소하시겠습니까?",
                "no-close-on-esc": "",
                "no-close-on-backdrop": "",
              },
              on: {
                ok: function ($event) {
                  $event.preventDefault()
                  return _vm.cancelOrder()
                },
              },
              model: {
                value: _vm.cancelModalVisible,
                callback: function ($$v) {
                  _vm.cancelModalVisible = $$v
                },
                expression: "cancelModalVisible",
              },
            },
            [
              _c("p", { staticClass: "mt-1" }, [
                _vm._v(
                  " 기프티콘업체: " + _vm._s(_vm.currentOrder.companyName) + " "
                ),
              ]),
              _c("p", [
                _vm._v(
                  " 보상구분: " + _vm._s(_vm.currentOrder.rewardTypeName) + " "
                ),
              ]),
              _c("p", [
                _vm._v(" 상품명: " + _vm._s(_vm.currentOrder.goodsName) + " "),
              ]),
              _c("p", [
                _vm._v(
                  " 휴대폰번호: " + _vm._s(_vm.currentOrder.phoneNumber) + " "
                ),
              ]),
              _c("p", [
                _vm._v(
                  " 발송일시: " + _vm._s(_vm.currentOrder.sendDateStr) + " "
                ),
              ]),
              _vm.failureMessage
                ? _c("p", { staticClass: "text-danger" }, [
                    _vm._v(" 실패메시지: " + _vm._s(_vm.failureMessage) + " "),
                  ])
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "b-modal",
            {
              attrs: {
                title: "기프티콘을 다시 발송 하시겠습니까?",
                "no-close-on-esc": "",
                "no-close-on-backdrop": "",
              },
              on: {
                ok: function ($event) {
                  $event.preventDefault()
                  return _vm.reOrder()
                },
              },
              model: {
                value: _vm.reOrderModalVisible,
                callback: function ($$v) {
                  _vm.reOrderModalVisible = $$v
                },
                expression: "reOrderModalVisible",
              },
            },
            [
              _c("p", { staticClass: "mt-1" }, [
                _vm._v(
                  " 기프티콘업체: " + _vm._s(_vm.currentOrder.companyName) + " "
                ),
                _vm.currentOrder.company === 2
                  ? _c("span", { staticClass: "text-primary" }, [
                      _vm._v(
                        ' (* 카카오 기프티콘의 경우 발송 시점에 성공 여부를 알 수 없습니다. (발송 접수 성공/실패 여부만 확인 가능) 따라서 성공으로 표시되더라도 3~4초 뒤에 목록을 다시 조회하시어 "실패"로 변경되지 않았는지 확인해 주세요.) '
                      ),
                    ])
                  : _vm._e(),
              ]),
              _c("p", [
                _vm._v(
                  " 보상구분: " + _vm._s(_vm.currentOrder.rewardTypeName) + " "
                ),
              ]),
              _c("p", [
                _vm._v(" 상품명: " + _vm._s(_vm.currentOrder.goodsName) + " "),
              ]),
              _c("p", [
                _vm._v(
                  " 휴대폰번호: " + _vm._s(_vm.currentOrder.phoneNumber) + " "
                ),
              ]),
              _c("p", [
                _vm._v(
                  " 발송실패일시: " + _vm._s(_vm.currentOrder.sendDateStr) + " "
                ),
              ]),
              _vm.failureMessage
                ? _c("p", { staticClass: "text-danger" }, [
                    _vm._v(" 실패메시지: " + _vm._s(_vm.failureMessage) + " "),
                  ])
                : _vm._e(),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }